// @flow
import { all } from 'redux-saga/effects';
import authenticationSaga from './AuthenticationSaga';
import documentsSaga from './DocumentsSaga';

export default function* root(): Generator<*, *, *> {
  yield all([...authenticationSaga, ...documentsSaga]);
}
